import React from 'react';

interface AccordionContextData {
  activeEventKey: string | number;
  onToggle: any;
}

export default React.createContext<AccordionContextData | null>(null);
